module.exports = __webpack_public_path__ + "img/2021_elife.e2b20763.jpg";